import { Group, GroupsByCategories } from 'components/context/types';
import t from 'utils/translations';
import { TreeSelect } from 'antd';
import * as React from 'react';
import { TreeNode } from 'antd/lib/tree-select';
import { NO_CATEGORY_ID } from 'components/pages/grouplistpage/GroupListPage';
import { useState } from 'react';
import { useEffect } from 'react';

function getChildNodes(groups: Group[]): TreeNode[] {
    return groups.map((group: Group) => {
        return {
            value: group.groupId,
            title: group.groupName,
            key: group.groupId
        };
    });
}

function getTreeNodeData(
    groupsAndCategories: GroupsByCategories[],
    allowCategorySelection?: boolean
): TreeNode[] {
    const tree = groupsAndCategories
        .filter(cat => cat.categoryId !== NO_CATEGORY_ID)
        .map((catGroups: GroupsByCategories) => {
            return {
                value: catGroups.categoryId,
                title: catGroups.categoryName,
                key: catGroups.categoryId,
                children: getChildNodes(catGroups.groups),
                disabled: allowCategorySelection !== true
            };
        });

    const unCategorizedCategory = groupsAndCategories.find(
        cat => cat.categoryId === NO_CATEGORY_ID
    );

    const unCategorizedGroups = unCategorizedCategory
        ? unCategorizedCategory.groups.map((group: Group) => ({
              value: group.groupId,
              title: group.groupName,
              key: group.groupId,
              children: [],
              disabled: false
          }))
        : [];

    tree.unshift(...unCategorizedGroups);

    return tree;
}

interface Props {
    allowCategorySelection?: boolean;
    groupsByCategories: GroupsByCategories[];
    onSelect: (value: string) => void;
    value?: string;
    disabled?: boolean;
}

function GroupTreeSelector({
    allowCategorySelection,
    groupsByCategories,
    onSelect,
    value,
    disabled
}: Props) {
    const [treeData, setTreeData] = useState<TreeNode[]>([] as TreeNode[]);

    useEffect(() => {
        const data: TreeNode[] = getTreeNodeData(
            groupsByCategories,
            allowCategorySelection
        );
        setTreeData(data);
    }, [groupsByCategories]);

    return (
        <TreeSelect
            treeData={treeData}
            onSelect={onSelect}
            placeholder={t('CHOOSE_GROUP')}
            treeDefaultExpandAll={true}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            value={value}
            disabled={disabled}
        />
    );
}

export default GroupTreeSelector;
